import { URI } from '@/config/config';

export default async ({ rootState }, body) => {
  console.log(body)
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
    body: JSON.stringify(body),
  };

  const userLoginInfoResult = await fetch(
    `${URI}control-panel/save-configurations`,
    opts,
  );
  const jsonResult = await userLoginInfoResult.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
